import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBroom } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { countriesClear, categoriesClear, skipSet, datesClear } from '../../store/filterSlice';
import { useTranslation } from 'react-i18next';
//
// Вспомогательный компонент для очистки списка выбранных категорий и стран
//
const FilterClear = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const dates = useSelector(state => state.filter.dates);
	const countries = useSelector(state => state.filter.countries);
	const categories = useSelector(state => state.filter.categories);
    const [ display, setDisplay ] = useState(false);

    useEffect(() => {
        if(dates.length || countries.length || categories.length) setDisplay(true); else setDisplay(false);
    }, [ dates, countries, categories ]);

    const onClear = () => {
        dispatch(categoriesClear());
        dispatch(countriesClear());
        dispatch(datesClear());
        dispatch(skipSet(0));
    };

    // Ничего не выбрано, компонент не надо отображать
    if(!display) return null;

    return (
        <div
            className='list'
            style={{
                marginTop:'1rem',
                borderTop:'1px solid var(--border-color)',
                paddingTop:'1rem',
            }}
        >
            <div className='item'>
                <div className='icon'>
                    <FontAwesomeIcon icon={faBroom} style={{color:'var(--accent-color)'}}/>
                </div>
                <div
                    className='text'
                    onClick={() => onClear()}
                    style={{
                        color:'var(--accent-color)',
                        textDecoration:'underline',
                        cursor:'pointer',
                    }}
                >
                    {t('filter.clear')}
                </div>
            </div>
        </div>
    );
};

export default FilterClear;
